import React from 'react';
import QRCodeGenerator from './QRCodeGenerator';
import { CameraIcon } from './Icons';
import './PhotoUploadArea.css';

interface PhotoUploadAreaProps {
  qrCodeValue: string;
  sessionId: string | null;
  onTakePhoto: () => void;
}

const PhotoUploadArea: React.FC<PhotoUploadAreaProps> = ({
  qrCodeValue,
  sessionId,
  onTakePhoto
}) => {
  return (
    <div className="upload-section">
      <div className="upload-instruction">
        <h4>扫码上传照片</h4>
        <p>使用手机扫描下方二维码，上传您的照片开始制作</p>
      </div>

      <div className="qr-code-container">
        <div className="qr-code-wrapper">
          <QRCodeGenerator 
            value={qrCodeValue}
            size={280}
            responsive={true}
            className="qr-code"
          />
          <div className="qr-code-overlay">
            <div className="scanning-line"></div>
          </div>
        </div>
        <p className="qr-code-text">
          扫描二维码上传照片
          {sessionId && (
            <span className="qr-session-info">
              ({sessionId.substring(8)})
            </span>
          )}
        </p>
      </div>

      <button 
        className="camera-button" 
        onClick={onTakePhoto}
      >
        <CameraIcon width="24" height="24" />
        现场拍照
      </button>
    </div>
  );
};

export default PhotoUploadArea;
